const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api/v1'

import type {
  TripAnnouncement,
  CreateAnnouncementDto,
  UpdateAnnouncementDto,
} from '@/shared/api/types'

export class AnnouncementsService {
  private baseUrl: string

  constructor(private getAccessToken: () => Promise<string | null> | string | null) {
    this.baseUrl = API_BASE_URL
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const token = await Promise.resolve(this.getAccessToken())
    const headers = new Headers({
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    })

    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      ...options,
      headers,
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({}))
      throw new Error(error.message || error.error || `HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data.data ?? data
  }

  getTripAnnouncements(tripId: string): Promise<TripAnnouncement[]> {
    return this.request<TripAnnouncement[]>(`/trips/${tripId}/announcements`)
  }

  createAnnouncement(tripId: string, dto: CreateAnnouncementDto): Promise<TripAnnouncement> {
    return this.request<TripAnnouncement>(`/trips/${tripId}/announcements`, {
      method: 'POST',
      body: JSON.stringify(dto),
    })
  }

  updateAnnouncement(id: string, dto: UpdateAnnouncementDto): Promise<TripAnnouncement> {
    return this.request<TripAnnouncement>(`/announcements/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(dto),
    })
  }

  deleteAnnouncement(id: string): Promise<void> {
    return this.request<void>(`/announcements/${id}`, {
      method: 'DELETE',
    })
  }
}
